<template>
  <widget
    v-if="transactions"
    :title="$tc('phrases.solarHomeSystemTransaction')"
    class="col-sm-7"
    :id="'shs-transactions'"
    :paginator="transactions.paginator"
    :subscriber="subscriber"
    :show_per_page="true"
    color="primary"
  >
    <md-card>
      <md-card-content>
        <md-table>
          <md-table-row>
            <md-table-head v-for="(item, index) in headers" :key="index">
              {{ item }}
            </md-table-head>
          </md-table-row>
          <md-table-row v-for="token in transactions.tokens" :key="token.id">
            <md-table-cell
              v-text="token.transaction.original_transaction_type"
            ></md-table-cell>
            <md-table-cell v-text="moneyFormat(token.amount)"></md-table-cell>
            <md-table-cell v-if="token.paid_for_type === 'App\\Models\\Token'">
              Token ({{ formatToken(token.paid_for.token) }})
            </md-table-cell>
            <md-table-cell v-else>
              {{ token.paid_for_type }}
            </md-table-cell>
            <md-table-cell
              v-if="token.paid_for_type === 'App\\Models\\Token'"
              v-text="
                token.paid_for.token_unit === 'days'
                  ? token.paid_for.token_amount + ' days'
                  : readable(token.paid_for.token_amount) + ' kWh'
              "
            ></md-table-cell>
            <md-table-cell v-else>-</md-table-cell>
            <md-table-cell
              v-text="timeForTimeZone(token.created_at)"
            ></md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
    </md-card>
  </widget>
</template>

<script>
import { currency } from "@/mixins/currency.js"
import { timing } from "@/mixins/timing.js"
import { token } from "@/mixins/token.js"
import { EventBus } from "@/shared/eventbus.js"
import Widget from "@/shared/Widget.vue"

export default {
  name: "SolarHomeSystemTransactions",
  mixins: [currency, timing, token],
  components: { Widget },
  props: {
    transactions: {
      type: Object,
      required: true,
    },
  },
  created() {
    EventBus.$on("pageLoaded", this.reloadList)
  },
  beforeDestroy() {
    EventBus.$off("pageLoaded", this.reloadList)
  },
  data() {
    return {
      subscriber: "shs.transactions",
      headers: [
        this.$tc("words.provider"),
        this.$tc("words.amount"),
        this.$tc("phrases.paidFor"),
        this.$tc("phrases.inReturn"),
        this.$tc("words.date"),
      ],
      tableName: "Solar Home System Transactions",
    }
  },
  methods: {
    reloadList(subscriber, data) {
      if (subscriber !== this.subscriber) {
        return
      }
      this.transactions.updateList(data)
      this.$forceUpdate()
      EventBus.$emit(
        "widgetContentLoaded",
        this.subscriber,
        this.transactions.tokens.length,
      )
      this.$emit("widget-loaded", "transactions")
    },
  },
}
</script>

<style scoped lang="scss"></style>
